import type { FindingDetailResponse } from '../../lib/api'

/** The recorded summary is scope, not a second security claim or an inferred resource name. */
export function FindingScope({ summary }: { summary?: string | null }) {
  if (!summary?.trim()) return null
  return <span className="finding-row-summary">
    <span className="finding-scope-label">Scope: </span>
    <span className="finding-scope-value">{summary}</span>
  </span>
}

/** Promote only explicitly named, plain-text subjects already present in the displayed evidence. */
export function FindingSubject({ evidence }: { evidence: FindingDetailResponse['evidence'] }) {
  const labels = new Set(['application', 'resource', 'resource name', 'server', 'storage account', 'deployment'])
  const subject = evidence.find(({ label, value }) =>
    labels.has(label.trim().toLowerCase()) && value.trim() !== '' &&
    !/^[\[{]/.test(value.trim()) && !/[\r\n]/.test(value) && value.length <= 512,
  )
  if (!subject) return null
  return <div className="finding-subject">
    <span className="finding-scope-label">{subject.label}: </span>
    <span className="finding-subject-value">{subject.value}</span>
  </div>
}
